
function getRuleParameter(ruleId) {
  // if (["1", "2", "3"].includes(ruleId)) {
  //     return parseInt(ruleId)
  // } else if (["0", "4"].includes(ruleId)) {
  //     return 0
  // } else {
  if (parseInt(ruleId) < 5) {
    return parseInt(ruleId)
  } else {
    throw Error("Invalid rule id provided.")
  }

};

// Helper function to normalize player object structure
const normalizePlayer = (player) => {
  if (!player) return null;

  try {
    const playerId = String(player.playerId || '');
    if (!playerId) {
      console.warn('Player missing ID in normalizePlayer:', player);
      return null;
    }

    // Handle character ID - ensure it's a string
    const characterId = String(player.characterId || '0');

    // Handle ELO - ensure it's a number
    const elo = Number.isFinite(Number(player.elo)) ? Number(player.elo) : 0;

    // Handle names - ensure they're strings and properly trimmed
    const firstName = String(player.firstName || '').trim();
    const lastName = String(player.lastName || '').trim();

    // Determine the best full name, defaulting to first + last if not provided
    let fullName = '';
    if (player.fullName && typeof player.fullName === 'string') {
      fullName = player.fullName.trim();
    } else if (firstName || lastName) {
      fullName = `${firstName} ${lastName}`.trim();
    } else {
      fullName = `Player ${playerId}`;
    }

    return {
      playerId,
      characterId,
      fullName,
      firstName,
      lastName,
      elo,

      // Preserve any additional properties
      ...Object.entries(player).reduce((acc, [key, value]) => {
        // Skip properties we've already handled
        const handledProps = [
          'playerId', 'characterId', 'fullName', 'firstName', 'lastName',
          'elo'
        ];
        if (!handledProps.includes(key)) {
          acc[key] = value;
        }
        return acc;
      }, {})
    };
  } catch (error) {
    console.error('Error normalizing player:', error, 'Player data:', player);
    return null;
  }
};

function rotateRacers(
  recentRacers,
  grandPrixRoster,
  ruleId,
  intendedGroupSize,
) {
  const ruleParameter = getRuleParameter(ruleId);
  const hasExplicitGroupSize = Number.isInteger(intendedGroupSize);
  const groupSize = Math.min(
    hasExplicitGroupSize ? intendedGroupSize : recentRacers.length,
    grandPrixRoster.length,
  );
  const normalizedRoster = grandPrixRoster.map(normalizePlayer).filter(Boolean);
  const rosterMap = new Map(normalizedRoster.map((player) => [player.playerId, player]));
  const currentRacers = recentRacers.map(normalizePlayer).filter(Boolean).map((player) => {
    const rosterPlayer = rosterMap.get(player.playerId);
    return rosterPlayer ? {
      ...rosterPlayer,
      characterId: player.characterId,
      place: player.place,
    } : player;
  });
  const participatingOriginals = currentRacers
    .filter((player) => player && rosterMap.has(player.playerId))
    .map((player) => player);
  const participatingIds = new Set(
    participatingOriginals.map((player) => player.playerId),
  );
  const updatedRoster = normalizedRoster.map((player) => {
    const recent = participatingOriginals.find(
      (candidate) => candidate.playerId === player.playerId,
    );
    return recent ? {
      ...player,
      characterId: recent.characterId,
    } : player;
  });
  const withoutPlace = (player) => {
    const nextPlayer = { ...player };
    delete nextPlayer.place;
    return nextPlayer;
  };

  if (ruleParameter === 0) {
    return {
      newRacers: (hasExplicitGroupSize ? updatedRoster : currentRacers)
        .slice(0, groupSize)
        .map(withoutPlace),
      grandPrixRoster: updatedRoster,
    };
  }

  const sortedParticipants = [...participatingOriginals]
    .sort((left, right) => Number(left.place) - Number(right.place));
  const availablePlayers = updatedRoster.filter(
    (player) => !participatingIds.has(player.playerId),
  );
  const keptPlayers = ruleParameter === 4
    ? []
    : sortedParticipants.slice(
      Math.max(0, sortedParticipants.length - ruleParameter),
    );
  const result = [...keptPlayers, ...availablePlayers];

  // Small rosters may not have enough non-participants to fill every slot.
  // Re-add rotated originals only after every eligible original was considered.
  if (ruleParameter !== 4 || hasExplicitGroupSize) {
    sortedParticipants.forEach((player) => {
      if (!result.some((candidate) => candidate.playerId === player.playerId)) {
        result.push(player);
      }
    });
  }

  return {
    newRacers: result.slice(0, groupSize).map(withoutPlace),
    grandPrixRoster: updatedRoster,
  };
};

module.exports.getRuleParameter = getRuleParameter;
module.exports.rotateRacers = rotateRacers;
